(function ()
{
    'use strict';

    angular
        .module('app.chamados', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.chamados', {
                url    : '/chamados',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/chamados/chamados.html',
                        controller : 'ChamadosController as vm'
                    }
                },
                resolve: {
                    Chamados: ChamadosPrep
                }
            });

        /** @ngInject */            
        function ChamadosPrep(ChamadoService) {

            return ChamadoService.getData();
        }          
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.chamados')
        .controller('ReopenController', ReopenController);

    /** @ngInject */
    function ReopenController($uibModalInstance, ChamadoService, Chamado)
    {
        var vm = this;

        // Data
        vm.chamado = Chamado;
        console.log(Chamado);
        vm.msg = {
            'ok': 'Essa ação não poderá ser desfeita. Deseja proceder com a reabertura deste chamado?',
            'invalidDate': 'O prazo de reabertura do chamado excedeu o período permitido (sete dias). Favor realizar um novo chamado.',
            'alreadyReopened': 'Este chamado já foi reaberto. Para novas solicitações, registre um novo chamado.'
        }
        
        // Methods
        vm.save = save;
        vm.cancel = cancel;
        
        
        //////////
        
        function save() {
            ChamadoService.reopen(vm.chamado)
                .then(function(data) {
                    console.log(data);
                    $uibModalInstance.close(data);
                });
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.chamados')
        .controller('ContentController', ContentController);

    /** @ngInject */
    function ContentController($uibModalInstance, Chamado)
    {
        var vm = this;

        // Data
        vm.chamado = Chamado;
        
        // Methods
        vm.close = close;
        
        //////////

        function close() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ui.router',
                'ui.bootstrap'
                
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.formulario', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.formulario', {
                url    : '/novo',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/formulario/formulario.html',
                        controller : 'SampleController as vm'
                    }
                },
                resolve: {
                    Data: DataServicePrep
                }
            });

        /** @ngInject */
        function DataServicePrep(DataService) {
            return DataService.getData();
        }             
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.formulario')
        .factory('DataService', DataService);

    /** @ngInject */
    function DataService($http, api)
    {
        
        var service = {
            getData: getData
        };

        function getData() {
            return $http.get(api.baseUrl + 'api/naturezas', {withCredentials: true})
                .then(getDataComplete)

            function getDataComplete(response) {
                return response.data;
            }
        }

        return service;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.formulario')
        .controller('SampleController', SampleController);

    /** @ngInject */
    function SampleController($rootScope, Data, $log, $state, ChamadoService, toaster) {
        
        var vm = this;                

        // Data
        vm.categories = Data;
        vm.optionSelected = null;
        vm.categorySelected = null;
        vm.classes = {
            'SISTEMAS': 'icon-cog',
            'REDE/INTERNET': 'icon-wifi',
            'IMPRESSORA': 'icon-printer',
            'COMPUTADOR/NOTEBOOK': 'icon-desktop-tower'
        };
        vm.form = {};
        vm.form.description;  
        vm.form.file;      
        vm.form.phone;
        vm.form.option = null;
        vm.form.category = null;
        vm.form.content;

        // Methods
        vm.select = select;
        vm.create = create;
        vm.setContent = setContent;
        //////////       

        function setContent() {
            if (vm.optionSelected !== undefined) {
                vm.form.option = vm.optionSelected.id;
                vm.form.content = vm.optionSelected.tag;
            }
        }

        function create() {

            ChamadoService.create(vm.form)
                .then(function (data) {

                    $rootScope.$broadcast('chamadoCreated', true);
                    
                    vm.form.description = '';
                    vm.form.phone = '';
                    vm.form.option = null;
                    
                    toaster.pop({
                        type: 'success',
                        title: 'Chamado realizado com sucesso',
                        timeout: 1500,
                        onHideCallback: function () {
                            $state.go('app.chamados');
                        }
                    });
                });
        }

        function select(category) {
            if (vm.categorySelected
                && category.id === vm.categorySelected.id) {
                
                vm.optionSelected = "";
                vm.categorySelected = null;
                vm.form.category = null;
            } else {
                vm.categorySelected = category;
                vm.form.category = category.id;
            }

            vm.form.option = null;
            vm.form.description = '';

        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.chamados')
        .factory('ChamadoService', ChamadoService);

    /** @ngInject */
    function ChamadoService($http, $log, api, Upload) {

        var service = {
            getData: getData,
            create: create,
            reopen: reopen
        };

        function getData() {
            return $http.get(api.baseUrl + 'api/chamados')
                .then(getDataComplete)
                .catch(getDataFailed);

            function getDataComplete(response) {
                var chamados = response.data;
                chamados.forEach(function (chamado) {

                    if (chamado.openedDate) {
                        chamado.openedDate = moment(chamado.openedDate).utc().toDate();
                    }

                    if (chamado.closedDate) {
                        chamado.closedDate = moment(chamado.closedDate).utc().toDate();
                    }
                }, this);

                return chamados;
            }

            function getDataFailed(error) {
            }
        }

        function create(form) {

            var data = {
                description: form.description,
                phone: form.phone,
                category: form.category,
                option: form.option,
                content: form.content
            };

            if (form.file) {
                data.file = form.file;
                console.log('uploading..');
                return upload();
            }
            else {
                console.log('posting..');
                return http();
            }

            function upload() {
                return Upload.upload({
                    url: api.baseUrl + 'api/chamados',
                    data: data,
                    headers: {
                        'Content-Type': form.file.type
                    },
                    withCredentials: true
                })
                    .then(postDataComplete)
                    .catch(postDataFailed);
            }

            function http() {
                return $http.post(api.baseUrl + 'api/chamados', { data: data })
                    .then(postDataComplete)
                    .catch(postDataFailed);
            }

            function postDataComplete(response) {
                return response.data;
            }

            function postDataFailed(error) {
                console.log(error);
            }
        }

        function reopen(data) {
            return $http.post(api.baseUrl + 'api/reabertos', $.param({ id: data.id }))
                .then(postDataComplete)
                ;//.catch(postDataFailed);

            function postDataComplete(response) {
                return response.data;
            }

            function postDataFailed(error) {
                console.log(error);
                return false;
            }
        }

        return service;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.chamados')
        .controller('ChamadosController', ChamadosController);

    /** @ngInject */
    function ChamadosController($scope, $element, $uibModal, toaster, Chamados) {
        var vm = this;

        // Data
        vm.chamados = Chamados;
        vm.color = {
            '#FF0000': '#D50000',
            '#00FF00': '#00C853'
        };

        vm.searchWrapper = false;
        vm.search = '';

        vm.query = {
            closed: false,
            startDate: '',
            dueDate: null
        };

        vm.selectedStartDate = moment.utc().subtract(1, 'months').toDate();
        vm.selectedDueDate = moment.utc().toDate();

        // Methods
        vm.getStatusClass = getStatusClass;
        vm.reopenDialog = reopenDialog;
        vm.showContent = showContent;
        vm.getColor = getColor;
        vm.openSearch = openSearch;
        vm.filterDate = filterDate;
        vm.dateCallback = dateCallback;

        //////////

        function dateCallback (ev) {
            console.log(ev);
        }

        function filterDate () {

            return function (item) {
                if (item.openedDate === null) return true;
                
                var itemDate = moment(item.openedDate);
                var s = moment(vm.selectedStartDate).toDate();
                var e = moment(vm.selectedDueDate).toDate();

                if (itemDate >= s && itemDate <= e) return true;
                return false;
            }
        }

        function openSearch() {
            vm.searchWrapper = true;
        }

        function getColor(color) {
            return vm.color[color] ? vm.color[color] : '#FF6D00';
        }

        function showContent(chamado) {
            $uibModal.open({
                templateUrl: 'app/main/chamados/dialogs/content/content-dialog.html',
                controller: 'ContentController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    Chamado: chamado
                }
            });
        }

        function reopenDialog(chamado) {
            $uibModal.open({
                templateUrl: 'app/main/chamados/dialogs/reopen/reopen-dialog.html',
                controller: 'ReopenController',
                controllerAs: 'vm',
                resolve: {
                    Chamado: chamado
                }
            })
                .result
                .then(function (data) {
                    if (data) {
                        updateChamado(data);
                        toaster.pop({
                            type: 'success',
                            title: 'Chamado realizado com sucesso',
                            timeout: 2000
                        });
                    } else {
                        toaster.pop({
                            type: 'error',
                            title: 'Erro inesperado.',
                            timeout: 2000
                        });
                    }
                });
        }

        function updateChamado(chamado) {
            for (var i = 0; i < vm.chamados.length; i++) {
                if (vm.chamados[i].id === chamado.id) {
                    vm.chamados[i] = chamado;
                }
            }
        }

        function getStatusClass(chamado) {

            if (chamado.closedDate !== null) {
                return 'closed';
            } else {
                return 'opened';
            }
        }

        // Fix date picker be able to reopen after closing it.
        $scope.$on('hidePicker', function () {

            
        });

    }
})();

/*!
 * Waves v0.6.4
 * http://fian.my.id/Waves
 *
 * Copyright 2014 Alfiana E. Sibuea and other contributors
 * Released under the MIT license
 * https://github.com/fians/Waves/blob/master/LICENSE
 */

;
(function (window) {
    'use strict';

    var Waves = Waves || {};
    var $$ = document.querySelectorAll.bind(document);

    // Find exact position of element
    function isWindow(obj) {
        return obj !== null && obj === obj.window;
    }

    function getWindow(elem) {
        return isWindow(elem) ? elem : elem.nodeType === 9 && elem.defaultView;
    }

    function offset(elem) {
        var docElem, win,
            box = {
                top: 0,
                left: 0
            },
            doc = elem && elem.ownerDocument;

        docElem = doc.documentElement;

        if (typeof elem.getBoundingClientRect !== typeof undefined) {
            box = elem.getBoundingClientRect();
        }
        win = getWindow(doc);
        return {
            top: box.top + win.pageYOffset - docElem.clientTop,
            left: box.left + win.pageXOffset - docElem.clientLeft
        };
    }

    function convertStyle(obj) {
        var style = '';

        for (var a in obj) {
            if (obj.hasOwnProperty(a)) {
                style += (a + ':' + obj[a] + ';');
            }
        }

        return style;
    }

    var Effect = {

        // Effect delay
        duration: 750,

        show: function (e, element) {

            // Disable right click
            if (e.button === 2) {
                return false;
            }

            var el = element || this;

            // Create ripple
            var ripple = document.createElement('div');
            ripple.className = 'waves-ripple';
            el.appendChild(ripple);

            // Get click coordinate and element witdh
            var pos = offset(el);
            var relativeY = (e.pageY - pos.top);
            var relativeX = (e.pageX - pos.left);
            var scale = 'scale(' + ((el.clientWidth / 100) * 10) + ')';

            // Support for touch devices
            if ('touches' in e) {
                relativeY = (e.touches[0].pageY - pos.top);
                relativeX = (e.touches[0].pageX - pos.left);
            }

            // Attach data to element
            ripple.setAttribute('data-hold', Date.now());
            ripple.setAttribute('data-scale', scale);
            ripple.setAttribute('data-x', relativeX);
            ripple.setAttribute('data-y', relativeY);

            // Set ripple position
            var rippleStyle = {
                'top': relativeY + 'px',
                'left': relativeX + 'px'
            };

            ripple.className = ripple.className + ' waves-notransition';
            ripple.setAttribute('style', convertStyle(rippleStyle));
            ripple.className = ripple.className.replace('waves-notransition', '');

            // Scale the ripple
            rippleStyle['-webkit-transform'] = scale;
            rippleStyle['-moz-transform'] = scale;
            rippleStyle['-ms-transform'] = scale;
            rippleStyle['-o-transform'] = scale;
            rippleStyle.transform = scale;
            rippleStyle.opacity = '1';

            rippleStyle['-webkit-transition-duration'] = Effect.duration + 'ms';
            rippleStyle['-moz-transition-duration'] = Effect.duration + 'ms';
            rippleStyle['-o-transition-duration'] = Effect.duration + 'ms';
            rippleStyle['transition-duration'] = Effect.duration + 'ms';

            rippleStyle['-webkit-transition-timing-function'] = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';
            rippleStyle['-moz-transition-timing-function'] = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';
            rippleStyle['-o-transition-timing-function'] = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';
            rippleStyle['transition-timing-function'] = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';

            ripple.setAttribute('style', convertStyle(rippleStyle));
        },

        hide: function (e) {
            TouchHandler.touchup(e);

            var el = this;
            var width = el.clientWidth * 1.4;

            // Get first ripple
            var ripple = null;
            var ripples = el.getElementsByClassName('waves-ripple');
            if (ripples.length > 0) {
                ripple = ripples[ripples.length - 1];
            } else {
                return false;
            }

            var relativeX = ripple.getAttribute('data-x');
            var relativeY = ripple.getAttribute('data-y');
            var scale = ripple.getAttribute('data-scale');

            // Get delay beetween mousedown and mouse leave
            var diff = Date.now() - Number(ripple.getAttribute('data-hold'));
            var delay = 350 - diff;

            if (delay < 0) {
                delay = 0;
            }

            // Fade out ripple after delay
            setTimeout(function () {
                var style = {
                    'top': relativeY + 'px',
                    'left': relativeX + 'px',
                    'opacity': '0',

                    // Duration
                    '-webkit-transition-duration': Effect.duration + 'ms',
                    '-moz-transition-duration': Effect.duration + 'ms',
                    '-o-transition-duration': Effect.duration + 'ms',
                    'transition-duration': Effect.duration + 'ms',
                    '-webkit-transform': scale,
                    '-moz-transform': scale,
                    '-ms-transform': scale,
                    '-o-transform': scale,
                    'transform': scale,
                };

                ripple.setAttribute('style', convertStyle(style));

                setTimeout(function () {
                    try {
                        el.removeChild(ripple);
                    } catch (e) {
                        return false;
                    }
                }, Effect.duration);
            }, delay);
        },

        // Little hack to make <input> can perform waves effect
        wrapInput: function (elements) {
            for (var a = 0; a < elements.length; a++) {
                var el = elements[a];

                if (el.tagName.toLowerCase() === 'input') {
                    var parent = el.parentNode;

                    // If input already have parent just pass through
                    if (parent.tagName.toLowerCase() === 'i' && parent.className.indexOf('waves-effect') !== -1) {
                        continue;
                    }

                    // Put element class and style to the specified parent
                    var wrapper = document.createElement('i');
                    wrapper.className = el.className + ' waves-input-wrapper';

                    var elementStyle = el.getAttribute('style');

                    if (!elementStyle) {
                        elementStyle = '';
                    }

                    wrapper.setAttribute('style', elementStyle);

                    el.className = 'waves-button-input';
                    el.removeAttribute('style');

                    // Put element as child
                    parent.replaceChild(wrapper, el);
                    wrapper.appendChild(el);
                }
            }
        }
    };


    /**
     * Disable mousedown event for 500ms during and after touch
     */
    var TouchHandler = {
        /* uses an integer rather than bool so there's no issues with
         * needing to clear timeouts if another touch event occurred
         * within the 500ms. Cannot mouseup between touchstart and
         * touchend, nor in the 500ms after touchend. */
        touches: 0,
        allowEvent: function (e) {
            var allow = true;

            if (e.type === 'touchstart') {
                TouchHandler.touches += 1; //push
            } else if (e.type === 'touchend' || e.type === 'touchcancel') {
                setTimeout(function () {
                    if (TouchHandler.touches > 0) {
                        TouchHandler.touches -= 1; //pop after 500ms
                    }
                }, 500);
            } else if (e.type === 'mousedown' && TouchHandler.touches > 0) {
                allow = false;
            }

            return allow;
        },
        touchup: function (e) {
            TouchHandler.allowEvent(e);
        }
    };


    /**
     * Delegated click handler for .waves-effect element.
     * returns null when .waves-effect element not in "click tree"
     */
    function getWavesEffectElement(e) {
        if (TouchHandler.allowEvent(e) === false) {
            return null;
        }

        var element = null;
        var target = e.target || e.srcElement;

        while (target.parentElement !== null) {
            if (!(target instanceof SVGElement) && target.className.indexOf('waves-effect') !== -1) {
                element = target;
                break;
            } else if (target.classList.contains('waves-effect')) {
                element = target;
                break;
            }
            target = target.parentElement;
        }

        return element;
    }

    /**
     * Bubble the click and show effect if .waves-effect elem was found
     */
    function showEffect(e) {
        var element = getWavesEffectElement(e);

        if (element !== null) {
            Effect.show(e, element);

            if ('ontouchstart' in window) {
                element.addEventListener('touchend', Effect.hide, false);
                element.addEventListener('touchcancel', Effect.hide, false);
            }

            element.addEventListener('mouseup', Effect.hide, false);
            element.addEventListener('mouseleave', Effect.hide, false);
        }
    }

    Waves.displayEffect = function (options) {
        options = options || {};

        if ('duration' in options) {
            Effect.duration = options.duration;
        }

        //Wrap input inside <i> tag
        Effect.wrapInput($$('.waves-effect'));

        if ('ontouchstart' in window) {
            document.body.addEventListener('touchstart', showEffect, false);
        }

        document.body.addEventListener('mousedown', showEffect, false);
    };

    /**
     * Attach Waves to an input element (or any element which doesn't
     * bubble mouseup/mousedown events).
     *   Intended to be used with dynamically loaded forms/inputs, or
     * where the user doesn't want a delegated click handler.
     */
    Waves.attach = function (element) {
        //FUTURE: automatically add waves classes and allow users
        // to specify them with an options param? Eg. light/classic/button
        if (element.tagName.toLowerCase() === 'input') {
            Effect.wrapInput([element]);
            element = element.parentElement;
        }

        if ('ontouchstart' in window) {
            element.addEventListener('touchstart', showEffect, false);
        }

        element.addEventListener('mousedown', showEffect, false);
    };

    window.Waves = Waves;

    document.addEventListener('DOMContentLoaded', function () {
        Waves.displayEffect();
    }, false);

})(window);
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($q, $log, $resource)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('pgFilter', pgFilter);

    /** @ngInject */
    function pgFilter() {
        return function (input, start) {
            if (input) {
                start = +start; //parse to int
                return input.slice(start);
            }
            return [];
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [
            'app.core',

            'toaster',

            'ngFileUpload',

            'angularUtils.directives.dirPagination',

            'app.formulario',
            
            'app.chamados',

            'datePicker'
        ]);
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('ConfigService', ConfigService);

    /** @ngInject */
    function ConfigService($rootScope, $http, $log, api)
    {
        
        var service = {
            getData: getData,
            amount: 0,
            user: ''
        };   

        function getData() {
            return $http.get(api.baseUrl + 'api/usuarios')
                .then(function(response) {

                    var data = {
                        amount: response.data.chamadosAmount,
                        user: response.data.user
                    };
                    service.amount = data.amount;
                    return data;
                })
                .catch(function(err) { console.log(err); });
        }       

        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope, ConfigService, Config)
    {
        // Data
        var vm = this;
        vm.amount = Config.amount;
        vm.user = Config.user.split(' ')[0];
        //////////

        $scope.$on('chamadoCreated', function(e, data) {
            vm.amount++;
        });

        // Remove the splash screen
        /*$scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });*/
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data
        //console.log(ChamadosCount);
        
        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseConfig)
    {

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        // toastr configuration
        toastr.options.timeOut = 3000;
        toastr.options.positionClass = 'toast-top-right';
        toastr.options.preventDuplicates = true;
        toastr.options.progressBar = true;

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $http, $timeout, $state)
    {

        $http.defaults.transformRequest.push(function (data) {
            $rootScope.loadingProgress = true;
            return data;
        });

        $http.defaults.transformResponse.push(function (data) {
            $rootScope.loadingProgress = false;
            return data;
        });              

        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider, msApiProvider)
    {
        if (!window.history || !window.history.pushState) {
            window.location.hash = '/';
            $locationProvider.hashPrefix('!');
        }
        
        $locationProvider.html5Mode(false);
        $locationProvider.hashPrefix('!');
        
        $urlRouterProvider.otherwise('/chamados');

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: 'app/layout/main.html',
                        controller : 'MainController as vm'
                    },
                    'navigation@app' : {
                        templateUrl: 'app/navigation/navigation.html',
                        controller: 'NavigationController as vm'
                    }
                },
                resolve: {
                    Config: prepConfigService
                }
            });
        
        /** @ngInject */
        function prepConfigService(ConfigService) {

                return ConfigService.getData();
        }

        msApiProvider.register('chamados', ['app/data/chamados/chamados.json']);            

    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController()
    {
        var vm = this;

        // Data

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($httpProvider)
    {
        /*$httpProvider.defaults.headers.common = {
            'Content-Type': 'application/json'
        };
        $httpProvider.defaults.headers.put = {};
        $httpProvider.defaults.headers.patch = {};*/     
        $httpProvider.defaults.withCredentials = true;

        $httpProvider.defaults.headers.post = {
            //'Content-Type': 'application/x-www-form-urlencoded'
            'Content-Type': 'application/json'
        };

        $httpProvider.defaults.headers.patch = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {

        var api = {};

        // Base Url
        //api.baseUrl = '/';
        api.baseUrl = '/HelpDesk/';
        //api.baseUrl = 'http://tce-v010:81/HelpDesk/';
        //api.baseUrl = 'http://info-008/HelpDesk/';
        return api;
    }

})();
angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/layout/main.html","<div id=\"main\" class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-10 col-md-offset-1\" ui-view=\"navigation\">\n</div></div><div class=\"row content\"><div ui-view=\"content\" class=\"\"></div></div></div>");
$templateCache.put("app/navigation/navigation.html","<nav class=\"navbar transparent\"><div class=\"navbar-header\"></div><div class=\"navbar-collapse\"><div class=\"col-md-6\"><a \nhref=\"#\" class=\"btn-flat waves-effect\" ui-sref-active=\"active\" ui-sref=\"app.formulario\"><i \nclass=\"material-icons icon-plus-circle-outline\"></i> Novo</a> <a href=\"#\" class=\"btn-flat waves-effect\" \nui-sref-active=\"active\" ui-sref=\"app.chamados\">Chamados <span class=\"badge\">{{vm.amount}}</span></a></div><div \nclass=\"col-md-1 text-left\"><div ng-if=\"$root.loadingProgress\" class=\"spinner-wrapper\" \nstyle=\"min-height:0;height:0;margin-top:-15px\"><div class=\"spinner\"><div class=\"inner\"><div class=\"gap\"></div><div \nclass=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\"></div></div></div></div>\n</div></div><div class=\"col-md-5 nav-user text-right\">Olá, {{vm.user}}</div></div></nav><hr>");
$templateCache.put("app/main/formulario/formulario.html","<div><div class=\"row\"><div class=\"col-lg-10 col-lg-offset-1 col-sm-12\"><div ng-click=\"vm.select(category)\" \nng-repeat=\"category in vm.categories track by $index\" class=\"col-md-3 col-sm-6 card-wrapper\"><div \nclass=\"card text-center\" ng-class=\"(vm.categorySelected.id === category.id) ? \'active\' : \'\'\"><div \nclass=\"card-block text-center\"><p></p><div ng-hide=\"vm.categorySelected !== null\"><i aria-hidden=\"true\" id=\"icon\" \nclass=\"{{vm.classes[category.tag]}}\"></i></div><p></p></div><div class=\"card-footer\">{{category.tag}}</div></div></div>\n</div></div><form name=\"form\"><div class=\"row animate-slide-up\" ng-show=\"vm.categorySelected !== null\"><div \nclass=\"col-md-8 panel panel-default col-md-offset-2\"><h5 class=\"card-header\">novo chamado</h5><div \nclass=\"panel-body text-center\"><div class=\"row\"><div class=\"col-md-9\"><div class=\"mdl-selectfield\"><select \nng-model=\"vm.optionSelected\" \nng-options=\"option.tag for option in vm.categorySelected.options | orderBy: \'tag\' track by option.tag\" \nng-change=\"vm.setContent()\" required><option value=\"\">Selecione um assunto</option></select></div></div><div \nclass=\"col-md-3\"><p class=\"input-group\"><span class=\"input-group-btn\"><i class=\"icon-phone\"></i> </span><input \nname=\"phone\" ng-model=\"vm.form.phone\" tooltip-placement=\"right\" uib-tooltip=\"ramal\" type=\"text\" class=\"form-control\" \nmaxlength=\"4\" minlength=\"4\" placeholder=\"1234\" required></p></div></div><div class=\"row\"><div class=\"col-md-12\"><div \nclass=\"row\"><div class=\"input-field col-md-12\"><label for=\"description\" style=\"padding-left:10px\">Descrição do ocorrido\n</label><textarea ng-model=\"vm.form.description\" id=\"description\" class=\"materialize-textarea\" \nstyle=\"padding-top:35px\" maxlength=\"2000\" ng-trim=\"false\" ng-required=\"true\"></textarea><span \nclass=\"character-counter\" ng-if=\"vm.form.description.length > 0\" \nstyle=\"float: right; font-size: 12px; height: 1px; margin-top: -14px\">{{ vm.form.description.length }} / 2000</span>\n</div></div></div></div><div class=\"row\"><div class=\"col-md-8 text-left\"><div class=\"fileUpload btn btn-secondary\"><i \nclass=\"icon-upload\"></i> <span style=\"font-weight:500\">ANEXAR ARQUIVO</span> <input ngf-select type=\"file\" \nng-model=\"vm.form.file\" class=\"upload\" ngf-max-size=\"5MB\"></div>{{vm.form.file.name}} <i ng-show=\"form.file.$error\">\nArquivo deve ter no máximo 5 MB.</i></div><div class=\"col-md-4 text-right\"><input type=\"submit\" ng-click=\"vm.create()\" \nvalue=\"enviar\" class=\"btn btn-default\" aria-label=\"enviar\" \nng-disabled=\"form.$invalid || form.$pristine || loadingProgress\"></div></div></div></div><div class=\"row\"><div \nclass=\"col-md-8 col-md-offset-2 text-right\"><a \nuib-popover=\"Por favor, entre em contato com a Central de Atendimento ao Usuário através dos ramais 4374 e 4586.\" \npopover-trigger=\"mouseenter\">Não encontrou o assunto desejado? <i class=\"fa icon-help-circle\" style=\"padding-left:6px\">\n</i></a></div></div></div></form></div><toaster-container></toaster-container><script type=\"text/ng-template\" \nid=\"myPopoverTemplate.html\"><div>aee</div></script>");
$templateCache.put("app/main/chamados/chamados.html","<div class=\"container-fluid meus-chamados\"><div class=\"row\"><div class=\"col-md-10 col-md-offset-1\"><h4>meus chamados\n</h4></div></div><div ng-if=\"vm.chamados.length > 0\" class=\"col-md-10 col-md-offset-1 panel panel-default\" \nstyle=\"margin-top: 0\"><div class=\"row page-title\"><div class=\"col-md-8 text-left\" style=\"padding-top:10px\"><div \nclass=\"row search-wrapper\"><div class=\"col-md-6\"><input type=\"text\" ng-model=\"vm.search\" class=\"search-input\" \nplaceholder=\"Busca por código, categoria, assunto ou conteúdo\"></div><div tooltip-placement=\"top\" \nuib-tooltip=\"Data inicial\" class=\"input-field col-md-3 date-input\"><input type=\"text\" auto-close=\"true\" date-time \nmax-view=\"date\" min-view=\"date\" vm. ng-model=\"vm.selectedStartDate\" format=\"DD/MM/YYYY\"></div><div \ntooltip-placement=\"top\" uib-tooltip=\"Data final\" class=\"input-field col-md-3 date-input\"><input type=\"text\" \nauto-close=\"true\" date-time max-view=\"date\" min-view=\"date\" class=\"dateinput\" ng-model=\"vm.selectedDueDate\" \nformat=\"DD/MM/YYYY\"></div></div></div><div class=\"col-md-4 text-right\" style=\"padding-top:10px\"><a \nclass=\"btn btn-default btn-md\" ng-click=\"vm.query.closed=false\" ng-class=\"(vm.query.closed) ? \'active\' : \'\'\" \nstyle=\"margin:0\">abertos</a> <a class=\"btn btn-default btn-md\" ng-click=\"vm.query.closed=true\" \nng-class=\"(!vm.query.closed) ? \'active\' : \'\'\" style=\"margin:0\">encerrados</a></div></div><div></div><ul \nclass=\"collection\"><li \ndir-paginate=\"chamado in vm.chamados | filter:{\'is_closed\':vm.query.closed} | filter: vm.filterDate() | filter: vm.search | itemsPerPage:5 as results\" \nclass=\"collection-item avatar animate-repeat\"><span class=\"status\" tooltip-placement=\"right\" \nuib-tooltip=\"{{chamado.status}}\" style=\"color: {{vm.getColor(chamado.color)}}\"><i \nclass=\"material-icons icon-checkbox-blank-circle\"></i></span><div ng-click=\"vm.showContent(chamado)\" \nclass=\"chamado-content\"><span class=\"title\">{{chamado.category.tag}}</span><p>{{chamado.option.tag}}<br><span \nclass=\"label simple\">Código: {{ chamado.id }}</span> <span class=\"label simple\">\naberto em {{ chamado.openedDate | date : \'dd/MM/yyyy - hh:mm\' }}</span> <span ng-if=\"chamado.closedDate\" \nclass=\"label label-default\" ng-hide=\"!chamado.is_closed && chamado.reopenStatus !== \'ok\'\">\nencerrado em {{ chamado.closedDate | date : \'dd/MM/yyyy - hh:mm\' }}</span></p></div><button ng-if=\"chamado.is_closed\" \nng-click=\"vm.reopenDialog(chamado)\" class=\"secondary-content btn btn-secondary\"><i class=\"icon-open-in-new\"></i>\n reabrir</button></li></ul><div ng-show=\"results.length == 0\" class=\"col-md-12 text-center\" style=\"margin:100px 0\"><div\n ng-if=\"vm.query.closed === false\"><h4>Nenhum chamado em aberto</h4><input type=\"button\" class=\"btn btn-default\" \nui-sref=\"app.formulario\" value=\"ABRIR UM CHAMADO\"></div><h4 ng-if=\"vm.query.closed === true\">\nNenhum chamado encerrado no período espeficicado</h4></div><dir-pagination-controls></dir-pagination-controls></div>\n<div ng-if=\"vm.chamados.length === 0\" class=\"col-md-8 col-md-offset-2 text-center\" style=\"margin-top: 100px\"><h4>\nVocê não possui nenhum chamado registrado.<h5>Abra um agora mesmo na opção \"novo\" acima.</h5></h4></div></div>\n<toaster-container></toaster-container>");
$templateCache.put("app/main/chamados/dialogs/content/content-dialog.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Chamado {{ vm.chamado.id }}</h3></div><div class=\"modal-body\"><p \nclass=\"text-justify\" style=\"padding:10px\"></p><div><div ng-if=\"vm.chamado.is_closed && vm.chamado.closedMessage\"><h5 \nclass=\"section-title st-teal\">Resposta <small>{{vm.chamado.closedMessage}} ({{vm.chamado.closedAuthor}})</small></h5>\n<hr></div>{{ vm.chamado.description }}<p></p></div><div class=\"modal-footer\"><div class=\"row\"><div \nclass=\"col-md-8 text-left\"><button disabled=\"disabled\" class=\"btn\" style=\"margin:0;cursor:default\">\nstatus: {{ vm.chamado.status }}</button> <a ng-if=\"vm.chamado.file\" style=\"margin:0\" ng-href=\"{{vm.chamado.file}}\" \ntarget=\"_blank\" class=\"btn-flat waves-effect\"><i class=\"material-icons icon-download\"></i> anexo</a></div><div \nclass=\"col-md-4 text-right\"><button class=\"btn btn-default\" type=\"button\" style=\"margin-top:0px\" ng-click=\"vm.close()\">\nFechar</button></div></div></div></div>");
$templateCache.put("app/main/chamados/dialogs/reopen/reopen-dialog.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Reabrir chamado {{ vm.chamado.id }}</h3></div><div \nclass=\"modal-body\"><p>{{ vm.msg[vm.chamado.reopenStatus] }}</p></div><div class=\"modal-footer\"><button \nclass=\"btn btn-warning\" type=\"button\" ng-click=\"vm.cancel()\">Cancelar</button> <button class=\"btn btn-default\" \nng-if=\"vm.chamado.reopenStatus === \'ok\'\" ng-disabled=\"loadingProgress\" type=\"button\" style=\"margin-top:0px\" \nng-click=\"vm.save()\">Sim</button></div>");
$templateCache.put("app/main/chamados/dialogs/search/search-dialog.html","<div class=\"modal-header\"><h3 class=\"modal-title\">{{ vm.chamado.id }}</h3></div><div class=\"modal-body\"><p></p></div>\n<div class=\"modal-footer\"><button class=\"btn btn-warning\" type=\"button\" ng-click=\"vm.cancel()\">Cancelar</button> \n<button class=\"btn btn-default\" ng-if=\"vm.chamado.reopenStatus === \'ok\'\" ng-disabled=\"loadingProgress\" type=\"button\" \nstyle=\"margin-top:0px\" ng-click=\"vm.save()\">Sim</button></div>");}]);